/** @type {Styles} */

export const styles = {
  activeStatusContainer: {
    backgroundColor: 'success.lightest',
    paddingY: 0.75,
    paddingX: 2.75,
    borderRadius: 1,
    boxSizing: 'border-box',
    width: 74,
    display: 'flex',
    justifyContent: 'center',
  },
  inactiveStatusContainer: {
    backgroundColor: (theme) => theme.palette.gray[8],
    paddingY: 0.75,
    paddingX: 2.75,
    borderRadius: 1,
    boxSizing: 'border-box',
    width: 84,
    display: 'flex',
    justifyContent: 'center',
  },
  inactiveStatusText: {
    color: (theme) => theme.palette.gray[64],
  },
}
